import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44dadd5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quote-section" }
const _hoisted_2 = {
  key: 0,
  class: "document-error"
}
const _hoisted_3 = { class: "quote-field" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_7 = {
  key: 1,
  class: "quote-field"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Download Repl. Cov. Notice ")
const _hoisted_9 = { class: "quote-field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_11 = {
  key: 2,
  class: "quote-field"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Product:", -1))
const _hoisted_13 = { class: "quote-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Premium:", -1))
const _hoisted_15 = { class: "quote-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Updated:", -1))
const _hoisted_17 = {
  key: 3,
  class: "quote-field"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Quote Issues:", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Issue", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasReplacementDocError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " There was an error downloading the replacement coverage document. "))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_3, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.quote.quoteNumber), 1),
      _hoisted_4,
      _createElementVNode("a", {
        href: _ctx.getQuoteLink(_ctx.quote),
        target: "_blank",
        class: "quote-link"
      }, "link", 8, _hoisted_5),
      _hoisted_6
    ]),
    (_ctx.isRollover && _ctx.shouldHaveReplacementDoc(_ctx.quote))
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
          _createElementVNode("a", {
            class: "download-link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.downloadReplacementDoc()), ["prevent"])),
            href: ""
          }, [
            _hoisted_8,
            _createVNode(_component_DownloadIcon)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_9, [
      _hoisted_10,
      _createTextVNode(" " + _toDisplayString(_ctx.quote.status), 1)
    ]),
    (!_ctx.isRollover)
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(_ctx.quote.product), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_13, [
      _hoisted_14,
      _createTextVNode(" " + _toDisplayString(_ctx.quote.premium), 1)
    ]),
    _createElementVNode("span", _hoisted_15, [
      _hoisted_16,
      _createTextVNode(" " + _toDisplayString(_ctx.quote.updateDate), 1)
    ]),
    (_ctx.hasQuoteIssues)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_ctx.quoteIssuesCollapsed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showQuoteIssues && _ctx.showQuoteIssues(...args)), ["prevent"])),
                  class: "button-link"
                }, "View quote issues")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.quoteIssuesCollapsed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideQuoteIssues && _ctx.hideQuoteIssues(...args)), ["prevent"])),
                  class: "button-link"
                }, "(hide)"),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quoteIssues.Entry, (issue) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: issue.LongDescription,
                    class: "issue-field"
                  }, [
                    _hoisted_22,
                    _hoisted_23,
                    _createTextVNode(": " + _toDisplayString(issue.LongDescription), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}